var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrowRight",
    transform: "translate(-1104 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5341",
    "data-name": "Group 5341"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 128,
    height: 128,
    transform: "translate(1104 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "back",
    transform: "translate(1141.226 528.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M121.815,67.666l-56.8,56.784a6.378,6.378,0,0,1-9.03-9.011l52.3-52.279L55.989,10.883a6.38,6.38,0,0,1,9.029-9.017l56.8,56.784A6.436,6.436,0,0,1,121.815,67.666Z",
    transform: "translate(-54.113 -0.001)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.4b87f984.svg";
export { ForwardRef as ReactComponent };